import { difference } from 'lodash';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  getCGISelectedStateUrl,
  getVisualizerUrl,
  computeImageSize,
  computeDefaultAngle,
  addBackground,
  addTransparency,
} from './cgiHelpers';

export const cgiDimensions = {
  gmds5: { width: '320', height: '178' },
  gmds1: { width: '480', height: '270' },
  gmds4: { width: '640', height: '360' },
  gmds2: { width: '960', height: '540' },
  gmds10: { width: '1920', height: '1080' },
  gmds11: { width: '2500', height: '1407' },
};

export const getSelectedStateCgiURL = (imageConfig) => {
  const {
    imageAngle,
    angles: { exteriorAngles, interiorAngles, wheelAngles, isInterior },
    background,
  } = imageConfig;
  const angle = computeDefaultAngle(
    imageAngle,
    exteriorAngles,
    interiorAngles,
    wheelAngles,
    isInterior
  );
  const imageUrl = getCGISelectedStateUrl({ ...imageConfig, angle });
  return addBackground(imageUrl, background);
};

const withCGI = (Component) => {
  const ComponentWithCgi = (props) => {
    const {
      brandBase,
      bodyStyle,
      responsive,
      cgiSize,
      imageSize,
      imageAngle,
      transparent,
      background,
      year,
      cgiUrl,
      isVisualizer,
      visualizerUrl,
      selections,
      style,
      isInterior,
      exteriorAngles,
      interiorAngles,
      wheelAngles,
      breakpoint,
      iframeRef,
      onIframeRpoToggle,
    } = props;

    const angle = computeDefaultAngle(
      imageAngle,
      exteriorAngles,
      interiorAngles,
      wheelAngles,
      isInterior
    );

    const [visualizerData, setVisualizerData] = useState({ url: '', rpos: [] });

    if (isVisualizer) {
      let url = visualizerData.url;
      const selectionDif = difference(selections.rpos, visualizerData.rpos);

      if (selectionDif.length > 1) {
        url = getVisualizerUrl(
          visualizerUrl,
          style,
          bodyStyle,
          year,
          brandBase,
          selections,
          background,
          angle
        );

        setVisualizerData({ url, rpos: selections.rpos });
      } else if (selectionDif.length === 1) {
        onIframeRpoToggle(selectionDif[0]);
        setVisualizerData({ ...visualizerData, rpos: selections.rpos });
      }

      return (
        <Component
          iframeUrl={url}
          selections={selections}
          iframeRef={iframeRef}
        />
      );
    }

    //TODO: Update all uses of withCGI to the new pattern so we can remove the optional parameter for computeImageSize
    const size = computeImageSize(
      breakpoint,
      cgiSize,
      imageSize,
      responsive,
      false
    );
    const dimensions = cgiDimensions[size];
    const imageUrl = getCGISelectedStateUrl({
      year,
      cgiUrl,
      selections,
      style,
      angle,
      size,
      isInterior,
    });

    if (background) {
      return (
        <Component
          dimensions={dimensions}
          image={addBackground(imageUrl, background)}
          classIdentifier={props.classIdentifier}
          {...props}
        />
      );
    }

    if (transparent) {
      return (
        <Component
          classIdentifier={props.classIdentifier}
          dimensions={dimensions}
          image={addTransparency(imageUrl)}
          {...props}
        />
      );
    }

    return (
      <Component
        classIdentifier={props.classIdentifier}
        dimensions={dimensions}
        image={imageUrl}
        {...props}
      />
    );
  };

  ComponentWithCgi.displayName = 'ComponentWithCgi';

  const mapStateToProps = (state) => {
    const { breakpoint } = state;

    const {
      brandBase,
      bodyStyle,
      year,
      cgiSize,
      exteriorAngles,
      interiorAngles,
      wheelAngles,
      urls: { cgiUrl, visualizerUrl },
    } = state.appResources;

    const { selections, style } = state.config;

    return {
      brandBase,
      bodyStyle,
      breakpoint,
      year,
      cgiSize,
      cgiUrl,
      visualizerUrl,
      selections,
      style,
      exteriorAngles,
      interiorAngles,
      wheelAngles,
    };
  };

  return connect(mapStateToProps)(ComponentWithCgi);
};

export default withCGI;
